module.exports = __webpack_public_path__ + "fonts/poppins-bolditalic-webfont.59c5aa01.woff";